import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';


export const retrievePaymentGateways = createAsyncThunk(
	'payment-gateway/retrievePaymentGateways',
	async (params: any) => {
		const res = await baseuri.get('/admin/payment-gateways', {
			params: { ...params },
		});
        console.log('payment gateways', res.data.data);
		return res.data.data;
	}
);

export const createPaymentGateway = createAsyncThunk(
	'payment-gateway/createPaymentGateway',
	async (data: any) => {
		const res = await baseuri.post('/admin/payment-gateways', data);
		message.success('Payment gateway created successfully!');
		return res.data.data;
	}
);
export const editPaymentGateway = createAsyncThunk(
	'payment-gateway/editPaymentGateway',
	async ({ id, data }: { id: any; data: any }) => {
		const res = await baseuri.put(`/admin/payment-gateways/${id}`, data);
		message.success(res?.data?.message);
		return res.data.data;
	}
);
export const deletePaymentGateway = createAsyncThunk(
    'payment-gateway/deletePaymentGateway',
    async (id: any) => {
        const res = await baseuri.delete(`/admin/payment-gateways/${id}`);
        message.success(res?.data?.message);
        return res.data.data;
    }
);


export const verifyAccountName = createAsyncThunk(
	'payment-gateway/verifyAccountName',
	async (data: any) => {
		const res = await baseuri.post('/admin/wallet/name-enquiry', data);
		message.success('Account name  verified successfully!');
		return res.data.data;
	}
);


const swapRx = createSlice({
    name: 'swap',
    initialState: {
        payementgateways: {
            itemsList: [],
            paginator: {
                itemCount: 0,
                currentPage: 1,
                perPage: 20,
                pageCount: 0,
            },
        },
     verifyAccount:{
        
     }
    },
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(retrievePaymentGateways.fulfilled, (store, action) => {
                const state = store;
                state.payementgateways = action.payload;
            })
            .addCase(verifyAccountName.fulfilled, (store, action) => {
                const state = store;
                state.verifyAccount = action.payload;
            })
});

export default swapRx.reducer;
